import ForecastRule from "@/types/ForecastRule.ts";
import ForecastRuleFetch from "@/types/ForecastRuleFetch.ts";
import ForecastRuleGet from "@/types/ForecastRuleGet.ts";

export const PROJECT_TABS = {
  DEFAULT: "ALL",
  ALL: "ALL",
  SIMPLE: "SIMPLE",
  AGGREGATED: "AGGREGATED",
  SUPPORT: "SUPPORT",
  OUTSOURCE: "OUTSOURCE",
  MONEYLESS: "MONEYLESS",
  HASH: {
    DEFAULT: "#all",
    ALL: "#all",
    SIMPLE: "#simple",
    SUPPORT: "#support",
    OUTSOURCE: "#outsource",
    MONEYLESS: "#public",
  },
};

export const RALLOC_TABS_ENUM = {
  EMPLOYEES: {
    value: "employees",
    label: "timeManagement.employees|Alkalmazottak",
  },
  PROJECTS: {
    value: "projects",
    label: "timeManagement.projects|Projektek",
  },
};

export const OVERTIME_REQUEST_STATUS = {
  ENUM: {
    REQUEST: "REQUEST",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    REVOKED: "REVOKED",
  },
  LABEL: {
    REQUEST: "overtimeRequestStatus.request|Kérvényezve",
    APPROVED: "overtimeRequestStatus.approved|Elfogadva",
    DENIED: "overtimeRequestStatus.denied|Elutasítva",
    REVOKED: "overtimeRequestStatus.revoked|Visszavonva",
  },
  COLORS: {
    REQUEST: "overtime-badge-blue",
    APPROVED: "overtime-badge-green",
    DENIED: "overtime-badge-red",
    REVOKED: "overtime-badge-blue",
  },
};

export const TEAM_LEAD_ROLE = {
  ENUM: {
    RESOURCE: "RESOURCE",
    FINANCIAL: "FINANCIAL",
  },
  LABEL: {
    RESOURCE: "teamLeadRole.resource|Erőforrás vezető",
    FINANCIAL: "teamLeadRole.financial|Pénzügyi vezető",
  },
  ICON: {
    RESOURCE: "business-time",
    FINANCIAL: "coins",
  },
};

export const PROJECT_STATUS_ENUM = {
  REQUEST: "REQUEST",
  CANCELLED: "CANCELLED",
  DENIED: "DENIED",
  APPROVED: "APPROVED",
  ONGOING: "ONGOING",
  ON_HOLD: "ON_HOLD",
  DONE: "DONE",
  CLOSED: "CLOSED",
};

export const USER_INDICATOR_TYPE_ENUM = {
  ROLE: "ROLE",
  SENIORITY: "SENIORITY",
  DEPARTMENT: "DEPARTMENT",
  COMPETENCY: "COMPETENCY",
};

export const USER_PERMISSION_TYPE_ENUM = {
  HAVE: "HAVE",
  SHOULD_HAVE: "SHOULD_HAVE",
  SHOULD_NOT_HAVE: "SHOULD_NOT_HAVE",
  NOT_HAVE: "NOT_HAVE",
};

export const USER_PERMISSION_TYPE_LABEL = {
  HAVE: "userPermissionType.have|Van",
  SHOULD_HAVE: "userPermissionType.shouldHave|Kéne",
  SHOULD_NOT_HAVE: "userPermissionType.shouldNotHave|Nem kéne",
  NOT_HAVE: "userPermissionType.notHave|Nincs",
};

export const OVERTIME_REQUEST_TYPE = {
  ENUM: {
    NONE: "NONE",
    SHIFT: "SHIFT",
    CASH: "CASH",
  },
  LABEL: {
    NONE: "overtimeRequestType.none|Nincs túlóra",
    SHIFT: "overtimeRequestType.shift|Csúsztatás",
    CASH: "overtimeRequestType.cash|Kifizetés",
  },
};

export const SHORT_MONTH_NAMES = [
  "month.short.january|jan",
  "month.short.february|feb",
  "month.short.march|már",
  "month.short.april|ápr",
  "month.short.may|máj",
  "month.short.june|jun",
  "month.short.july|júl",
  "month.short.august|aug",
  "month.short.september|szep",
  "month.short.october|okt",
  "month.short.november|nov",
  "month.short.december|dec",
];

export const DAY_NAME_SHORT_LABEL = {
  MONDAY: "day.short.monday|HÉ",
  TUESDAY: "day.short.tuesday|KE",
  WEDNESDAY: "day.short.wednesday|SZE",
  THURSDAY: "day.short.thursday|CS",
  FRIDAY: "day.short.friday|PÉ",
  SATURDAY: "day.short.saturday|SZO",
  SUNDAY: "day.short.sunday|VA",
};

export const DAY_NUMBER_LABEL = {
  1: "day.monday|Hétfő",
  2: "day.tuesday|Kedd",
  3: "day.wednesday|Szerda",
  4: "day.thursday|Csütörtök",
  5: "day.friday|Péntek",
  6: "day.saturday|Szombat",
  0: "day.sunday|Vasárnap",
};

export const DAY_NUMBER_SHORT_LABEL = {
  1: "day.letter.monday|H",
  2: "day.letter.tuesday|K",
  3: "day.letter.wednesday|Sze",
  4: "day.letter.thursday|Cs",
  5: "day.letter.friday|P",
  6: "day.letter.saturday|Szo",
  0: "day.letter.sunday|V",
};

export const DAY_SHORT_LABEL = {
  1: "day.short.monday|HÉ",
  2: "day.short.tuesday|KE",
  3: "day.short.wednesday|SZE",
  4: "day.short.thursday|CS",
  5: "day.short.friday|PÉ",
  6: "day.short.saturday|SZO",
  0: "day.short.sunday|VA",
};

export const PROJECT_BASE_DATA_TYPE = {
  ENUM: {
    SERVICE_TYPE: "SERVICE_TYPE",
    SALES_TYPE: "SALES_TYPE",
    INCOME_TYPE: "INCOME_TYPE",
    TECHNOLOGIES: "TECHNOLOGIES",
    LABOR_TYPES: "LABOR_TYPES",
    PRICING_MODEL: "PRICING_MODEL",
    MANAGEMENT_TYPE: "MANAGEMENT_TYPE",
  },
  LABEL: {
    TAB_ITEM: {
      SERVICE_TYPE: "projectBaseDataType.tab.serviceType|Szolgáltatás típusok",
      SALES_TYPE: "projectBaseDataType.tab.salesType|Sales típusok",
      INCOME_TYPE: "projectBaseDataType.tab.incomeType|Árbevétel típusok",
      TECHNOLOGIES: "projectBaseDataType.tab.technologies|Technológiák",
      LABOR_TYPES: "projectBaseDataType.tab.laborTypes|Feladattípusok",
      PRICING_MODEL: "projectBaseDataType.tab.pricingModel|Árazások",
      MANAGEMENT_TYPE:
        "projectBaseDataType.tab.managementType|Szervezéstípusok",
    },
    NEW_BUTTON: {
      SERVICE_TYPE:
        "projectBaseDataType.button.serviceType|Új szolgáltatás típus felvétele",
      SALES_TYPE:
        "projectBaseDataType.button.salesType|Új sales típus felvétele",
      INCOME_TYPE:
        "projectBaseDataType.button.incomeType|Új árbevétel típus felvétele",
      TECHNOLOGIES:
        "projectBaseDataType.button.technologies|Új technológia felvétele",
      LABOR_TYPES:
        "projectBaseDataType.button.laborTypes|Új feladattípus felvétele",
      PRICING_MODEL:
        "projectBaseDataType.button.pricingModel|Új árazás felvétele",
      MANAGEMENT_TYPE:
        "projectBaseDataType.button.managementType|Új szervezéstípus felvétele",
    },
    NEW_TITLE: {
      SERVICE_TYPE:
        "projectBaseDataType.newTitle.serviceType|Új szolgáltatás típus felvétele",
      SALES_TYPE:
        "projectBaseDataType.newTitle.salesType|Új sales típus felvétele",
      INCOME_TYPE:
        "projectBaseDataType.newTitle.incomeType|Új árbevétel típus felvétele",
      TECHNOLOGIES:
        "projectBaseDataType.newTitle.technologies|Új technológia felvétele",
      LABOR_TYPES:
        "projectBaseDataType.newTitle.laborTypes|Új feladattípus felvétele",
      PRICING_MODEL:
        "projectBaseDataType.newTitle.pricingModel|Új árazás felvétele",
      MANAGEMENT_TYPE:
        "projectBaseDataType.newTitle.managementType|Új szervezéstípus felvétele",
    },
    EDIT_TITLE: {
      SERVICE_TYPE:
        "projectBaseDataType.editTitle.serviceType|Szolgáltatás típus módosítása",
      SALES_TYPE:
        "projectBaseDataType.editTitle.salesType|Sales típus módosítása",
      INCOME_TYPE:
        "projectBaseDataType.editTitle.incomeType|Árbevétel típus módosítása",
      TECHNOLOGIES:
        "projectBaseDataType.editTitle.technologies|technológia módosítása",
      LABOR_TYPES:
        "projectBaseDataType.editTitle.laborTypes|Feladattípus módosítása",
      PRICING_MODEL:
        "projectBaseDataType.editTitle.pricingModel|Árazás módosítása",
      MANAGEMENT_TYPE:
        "projectBaseDataType.editTitle.managementType|Szervezéstípus módosítása",
    },
  },
};

export const FORECAST_YEAR_STATUS = {
  ENUM: {
    INACTIVE: "INACTIVE",
    ACTIVE: "ACTIVE",
    CLOSED: "CLOSED",
  },
  LABEL: {
    INACTIVE: "forecastYearStatus.inactive|Inaktív",
    ACTIVE: "forecastYearStatus.active|Aktív",
    CLOSED: "forecastYearStatus.closed|Lezárt",
  },
};

export const FORECAST_YEAR_QUARTER = {
  Q1: "Q1",
  Q2: "Q2",
  Q3: "Q3",
  Q4: "Q4",
};

export const FORECAST_RULES = [
  new ForecastRule(
    "ACCOUNT",
    "forecastRules.account|Ügyfél",
    "forecastRules.accountTypeSelected|Kiválasztott ügyfelek:",
    new ForecastRuleFetch("enterprise_clients/fetchClients", undefined),
    new ForecastRuleGet("enterprise_clients/clients", "id", "name", undefined),
    "user"
  ),
  new ForecastRule(
    "SERVICE_TYPE",
    "forecastRules.serviceType|Szolgáltatás típusa",
    "forecastRules.serviceTypeSelected|Kiválasztott kategóriák:",
    new ForecastRuleFetch("project_base_data/fetchByType", {
      type: "SERVICE_TYPE",
    }),
    new ForecastRuleGet(
      "project_base_data/getByType",
      "id",
      "name",
      "SERVICE_TYPE"
    ),
    "cogs"
  ),
  new ForecastRule(
    "INCOME_TYPE",
    "forecastRules.incomeType|Árbevétel típusa",
    "forecastRules.incomeTypeSelected|Kiválasztott kategóriák:",
    new ForecastRuleFetch("project_base_data/fetchByType", {
      type: "INCOME_TYPE",
    }),
    new ForecastRuleGet(
      "project_base_data/getByType",
      "id",
      "name",
      "INCOME_TYPE"
    ),
    "money-bill-wave"
  ),
  new ForecastRule(
    "SALES_TYPE",
    "forecastRules.salesType|Sales típusa",
    "forecastRules.salesTypeSelected|Kiválasztott kategóriák:",
    new ForecastRuleFetch("project_base_data/fetchByType", {
      type: "SALES_TYPE",
    }),
    new ForecastRuleGet(
      "project_base_data/getByType",
      "id",
      "name",
      "SALES_TYPE"
    ),
    "chart-line"
  ),
];

export const DEBUG_LANGUAGE = "DEBUG";

export const romanMatrix = [
  [1000, "M"],
  [900, "CM"],
  [500, "D"],
  [400, "CD"],
  [100, "C"],
  [90, "XC"],
  [50, "L"],
  [40, "XL"],
  [10, "X"],
  [9, "IX"],
  [5, "V"],
  [4, "IV"],
  [1, "I"],
];

export const UI_THEMES = {
  SYSTEM: "SYSTEM",
  DARK: "DARK",
  LIGHT: "LIGHT",
};

export const CURRENCY_TIERS = {
  LEVEL_ZERO: 0,
  LEVEL_ONE: 1,
  LEVEL_TWO: 2,
};

export const FORECAST_DASHBOARD_TYPE = {
  PLAN: "PLAN",
  FACT: "FACT",
  FORECASTED: "FORECASTED",
  DIFF: "DIFF",
};

export const ISSUE_STATUS = {
  TODO: {
    enum: "TODO",
    label: "projectPage.tasks.list.status.todo|Nyitott",
  },
  IN_PROGRESS: {
    enum: "IN_PROGRESS",
    label: "projectPage.tasks.list.status.inProgress|Folyamatban",
  },
  DONE: {
    enum: "DONE",
    label: "projectPage.tasks.list.status.done|Kész",
  },
};

export const ISSUE_TRACKING_SYSTEM = {
  SELF: {
    enum: "SELF",
    label: "issueTrackingSystem.self|Forecastify",
    class: "SelftrackingIssueTargetingRequest",
  },
  JIRA: {
    enum: "JIRA",
    label: "issueTrackingSystem.jira|Jira",
    generateUrl: () =>
      "https://id.atlassian.com/manage-profile/security/api-tokens",
    image: "@/assets/images/onboarding/jira_api_token.png",
    class: "JiraIssueTargetingRequest",
    issuePageUrl: (key) => `/browse/${key}`,
  },
  YOUTRACK: {
    enum: "YOUTRACK",
    label: "issueTrackingSystem.youTrack|YouTrack",
    generateUrl: () =>
      "https://www.jetbrains.com/help/youtrack/server/manage-authentication-tokens.html",
    image: "@/assets/images/onboarding/youtrack_api_token.png",
    class: "YouTrackIssueTargetingRequest",
    issuePageUrl: (key) => `/issue/${key}`,
  },
};

export const API_KEY_TYPES = {
  ISSUE_TRACKING: {
    JIRA: "Jira",
    YOUTRACK: "YouTrack",
  },
  GENERATE: {
    FORECASTIFY: "Forecastify",
  },
  OTHER: {
    GITLAB: "GitLab",
  },
};

export const PROJECT_TYPES = {
  BASIC: "BASIC",
  OUTSOURCE: "OUTSOURCE",
  SUPPORT: "SUPPORT",
  MONEYLESS: "MONEYLESS",
};

export const TASK_TYPE = {
  DEV: "taskType.dev|Fejlesztés",
  BUG: "taskType.bug|Hibajavítás",
  GENERAL: "taskType.general|Általános",
  OTHER: "taskType.other|Egyéb",
};

export const RALLOC_PRIORITY = {
  LOW: {
    order: 1,
    value: "LOW",
    token: "ralloc.priority.low|Bench Foglalás",
    color: "is-info",
    icon: "bullseye",
  },
  MEDIUM: {
    order: 2,
    value: "MEDIUM",
    token: "ralloc.priority.medium|Normál foglalás",
    color: "is-success",
    icon: "",
  },
  HIGH: {
    order: 3,
    value: "HIGH",
    token: "ralloc.priority.high|Kritikus Foglalás",
    color: "is-danger",
    icon: "lock",
  },
};

export const WORK_SCHEDULE_INDEXES = [
  { hours: "mondayHours", site: "mondaySite" },
  { hours: "tuesdayHours", site: "tuesdaySite" },
  { hours: "wednesdayHours", site: "wednesdaySite" },
  { hours: "thursdayHours", site: "thursdaySite" },
  { hours: "fridayHours", site: "fridaySite" },
  { hours: "saturdayHours", site: "saturdaySite" },
  { hours: "sundayHours", site: "sundaySite" },
];

export const INVOICE_STATUS = {
  DUE: {
    enum: "DUE",
    token: "invoice.status.due|Fizetendő",
    type: "is-info",
  },
  PAID: {
    enum: "PAID",
    token: "invoice.status.paid|Fizetett",
    type: "is-success",
  },
  CANCELLED: {
    enum: "CANCELLED",
    token: "invoice.status.cancelled|Visszavonva",
    type: "is-warning",
  },
};

export const UPLOAD_ACCEPT = {
  IMAGE: "image/*",
  SPREADSHEET:
    ".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv",
};

export const AFFILIATION_TYPE = {
  INTERNAL: {
    enum: "INTERNAL",
    label: "resource.employeeSelect.affiliation.internal|Belsős",
  },
  EXTERNAL: {
    enum: "EXTERNAL",
    label: "resource.employeeSelect.affiliation.external|Külsős",
  },
};

export const ISSUE_TRACKING_CONST = {
  PRIMARY_ISSUE_TRACKING_CONFIG_KEY: "DEFAULT",
  ISSUE_TRACKING_IDENTIFIER_FIELD: "identifier",
};

export const ABSENCE_REQUEST_STATUSES = {
  REQUEST: {
    enum: "REQUEST",
    label: "absenceRequests.status.request",
    shortLabel: "absenceRequests.status.request.short",
  },
  LINE_APPROVED: {
    enum: "LINE_APPROVED",
    label: "absenceRequests.status.lineApproved",
    shortLabel: "absenceRequests.status.lineApproved.short",
  },
  APPROVED: {
    enum: "APPROVED",
    label: "absenceRequests.status.approved",
    shortLabel: "absenceRequests.status.approved.short",
  },
  ACTIVE: {
    enum: "ACTIVE",
    label: "absenceRequests.status.active",
    shortLabel: "absenceRequests.status.active.short",
  },
  REVOKED: {
    enum: "REVOKED",
    label: "absenceRequests.status.revoked",
    shortLabel: "absenceRequests.status.revoked.short",
  },
  TAKEN: {
    enum: "TAKEN",
    label: "absenceRequests.status.taken",
    shortLabel: "absenceRequests.status.taken.short",
  },
  CLARIFY: {
    enum: "CLARIFY",
    label: "absenceRequests.status.clarify",
    shortLabel: "absenceRequests.status.clarify.short",
  },
  DENIED: {
    enum: "DENIED",
    label: "absenceRequests.status.denied",
    shortLabel: "absenceRequests.status.denied.short",
  },
};

export const COMPETENCY_PROFICIENCIES = {
  BEGINNER: {
    enum: "BEGINNER",
    label: "competency.proficiency.beginner|Kezdő",
    severity: "info",
    order: 3,
  },
  INTERMEDIATE: {
    enum: "INTERMEDIATE",
    label: "competency.proficiency.intermediate|Középhaladó",
    severity: "warning",
    order: 2,
  },
  ADVANCED: {
    enum: "ADVANCED",
    label: "competency.proficiency.advanced|Haladó",
    severity: "success",
    order: 1,
  },
  EXPERT: {
    enum: "EXPERT",
    label: "competency.proficiency.expert|Szakértő",
    severity: "danger",
    order: 0,
  },
};

export const TIME_MANAGEMENT_LOGGING_TABS = {
  DAILY: "daily",
  TIMESHEET: "timesheet",
  IMPORT: "import",
  CALENDAR: "calendar",
};

export const DAY_TYPE = {
  WEEKEND: "WEEKEND",
  WEEKDAY: "WEEKDAY",
  ABSENCE: "ABSENCE",
  HOLIDAY: "HOLIDAY",
};

export const OVERVIEW_TABS = {
  LOGGED_TIME: {
    value: "loggedTime",
    label: "timeManagement.loggedTime|Logolások",
  },
  TIME_OFF: {
    value: "timeOff",
    label: "timeManagement.timeOff|Szabadságok",
  },
};

export const INTERVAL = {
  DAILY: "daily",
  WEEKLY: "weekly",
};

export const DEPTH = {
  ROOT: "ROOT",
  CHILD: "CHILD",
};

export const CONTRACT_TYPES = {
  MILESTONE: "MILESTONE",
  SERVICE: "SERVICE",
  RECURRING: "RECURRING",
};

export const LINE_ITEM_TYPES = {
  FIX: "FIX",
  T_M: "T_M",
  NON_BILLABLE: "NON_BILLABLE",
};

export const LINE_ITEM_STATUSES = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  FUTURE: "FUTURE",
  COMPLETED: "COMPLETED",
};

export const CONTRACT_CURRENCIES = {
  EUR: "EUR",
  USD: "USD",
  HUF: "HUF",
};

export const OVERVIEW_THRESHOLD_SETTING_KEYS = {
  OVERALL_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD:
    "OVERALL_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD",
  PROJECT_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD:
    "PROJECT_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD",
};

export const HANDLE_WEEKEND_COLUMN_APPEARANCE = {
  OVERVIEW_LOGGED_TIME_TAB: "OVERVIEW_LOGGED_TIME_TAB",
  RESOURCE_PLANNER_EMPLOYEE_TAB: "RESOURCE_PLANNER_EMPLOYEE_TAB",
  RESOURCE_PLANNER_PROJECT_TAB: "RESOURCE_PLANNER_PROJECT_TAB",
};

export const PROFILE_TABS_ENUM = {
  OVERVIEW: "OVERVIEW",
  COMPETENCIES: "COMPETENCIES",
  WORKLOGS: "WORKLOGS",
  WORK_SCHEDULE: "WORK_SCHEDULE",
  RATE_CARD: "RATE_CARD",
  HOLIDAYS: "HOLIDAYS",
  PERMISSIONS: "PERMISSIONS",
  SECURITY: "SECURITY",
};

export const SYNC_STATUS = {
  SYNCED: {
    enum: "SYNCED",
    label: "syncStatus.synced",
    icon: "fa-check text-emerald-500",
    parentStyle: "bg-emerald-50 dark:bg-emerald-950",
  },
  NOT_SYNCED: {
    enum: "NOT_SYNCED",
    label: "syncStatus.not_synced",
    icon: "fa-exclamation-triangle text-surface-500",
    parentStyle: "bg-surface-50 dark:bg-surface-200",
  },
  SYNC_ERROR: {
    enum: "SYNC_ERROR",
    label: "syncStatus.sync_error",
    icon: "fa-exclamation text-red-500",
    parentStyle: "bg-red-50 dark:bg-red-950",
  },
  SYNC_IN_PROGRESS: {
    enum: "SYNC_IN_PROGRESS",
    label: "syncStatus.sync_in_progress",
    icon: "fa-rotate animate-spin text-orange-500",
    parentStyle: "bg-orange-50 dark:bg-orange-950",
  },
};

export const DATE_PICKER_LOCALES = {
  hu: {
    dayNamesMin: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
    dayNamesShort: ["Vas", "Hét", "Ke", "Sze", "Csü", "Pén", "Szo"],
    dayNames: [
      "Vasárnap",
      "Hétfő",
      "Kedd",
      "Szerda",
      "Csütörtök",
      "Péntek",
      "Szombat",
    ],
    monthNames: [
      "Január",
      "Február",
      "Március",
      "Április",
      "Május",
      "Június",
      "Július",
      "Augusztus",
      "Szeptember",
      "Október",
      "November",
      "December",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Már",
      "Ápr",
      "Máj",
      "Jún",
      "Júl",
      "Aug",
      "Sze",
      "Okt",
      "Nov",
      "Dec",
    ],
  },
  en: {
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
  },
};

export const CUSTOM_DATE_RANGES_LABELS = {
  DEFAULT: "customDateRanges.default",
  THIS_MONTH: "customDateRanges.this_month",
  THIS_QUARTER: "customDateRanges.this_quarter",
  NEXT_MONTH: "customDateRanges.next_month",
  NEXT_QUARTER: "customDateRanges.next_quarter",
  LAST_MONTH: "customDateRanges.last_month",
  LAST_QUARTER: "customDateRanges.last_quarter",
};
